import React, { useRef, useState } from "react";
import {
    FiUploadCloud,
    FiTrash2,
    FiCheckCircle,
    FiFile,
} from "react-icons/fi";
import "./DocumentUpload.scss";

const ALLOWED_EXTENSIONS = [
    "pdf",
    "doc",
    "docx",
    "ppt",
    "pptx",
    "xls",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
    "webp",
];


const MAX_FILES = 5;
const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB

const DocumentUpload = ({ documents, setDocuments, setErrors, errors }) => {
    const fileInputRef = useRef(null);
    const [error, setError] = useState("");
    const handleFiles = (files) => {
        const selectedFiles = Array.from(files);

        setErrors("");



        // Maximum 5 files validation
        if (documents.length + selectedFiles.length > MAX_FILES) {
            setError("You can upload a maximum of 5 files.");
            return;
        }

        const validFiles = [];

        for (const file of selectedFiles) {

            const extension = file.name.split(".").pop()?.toLowerCase();
            if (!ALLOWED_EXTENSIONS.includes(extension)) {
                setError(
                    `${file.name} is not a supported file type.`
                );
                return;
            }
            else {
                setError("")
            }
            // File size validation
            if (file.size > MAX_FILE_SIZE) {
                setError(
                    `${file.name} exceeds the maximum size of 25 MB.`
                );
                continue;
            }

            validFiles.push(file);
        }

        setDocuments((prev) => [...prev, ...validFiles]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        handleFiles(e.dataTransfer.files);
    };

    const removeFile = (index) => {
        setError("");
        setDocuments((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };

    const formatFileSize = (bytes) => {
        return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    };

    return (
        <div className="upload-section">
            <div
                className="upload-container"
                onDrop={handleDrop}
                onDragOver={(e) =>
                    e.preventDefault()
                }
            >
                <div className="upload-left">
                    <FiUploadCloud className="upload-icon" />

                    <p>
                        Drag & drop files here or{" "}
                        <span
                            className="browse-link"
                            onClick={() =>
                                fileInputRef.current?.click()
                            }
                        >
                            click to browse
                        </span>
                    </p>

                    <small>
                        You can upload multiple files
                        (Up to 25 MB each)
                    </small>

                    <button
                        type="button"
                        className="browse-btn"
                        onClick={() =>
                            fileInputRef.current?.click()
                        }
                    >
                        Browse Files
                    </button>

                    <input
                        type="file"
                        multiple
                        hidden
                        accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.jpg,.jpeg,.webp,.png"
                        ref={fileInputRef}
                        onChange={(e) =>
                            handleFiles(
                                e.target.files
                            )
                        }
                    />

                </div>

                <div className="upload-divider" />

                <div className="upload-right">
                    <h4>Supported file types</h4>

                    <div className="file-types">
                        <span>PDF</span>
                        <span>PPT</span>
                        <span>DOC</span>
                        <span>XLS</span>
                        <span>Images</span>
                    </div>
                </div>
            </div>

            {error && <p className="upload-error">{error}</p>}
            <p className="upload-error">{errors}</p>
            {documents.length > 0 && (
                <>
                    <h3 className="files-heading">
                        Uploaded Files (
                        {documents.length})
                    </h3>

                    <div className="files-list">
                        {documents.map(
                            (file, index) => (
                                <div
                                    key={index}
                                    className="file-card"
                                >
                                    <div className="file-info">
                                        <FiFile className="file-icon" />

                                        <div>
                                            <h4>
                                                {
                                                    file.name
                                                }
                                            </h4>

                                            <p>
                                                {formatFileSize(
                                                    file.size
                                                )}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="file-actions">
                                        <FiCheckCircle className="success-icon" />

                                        <button
                                            type="button"
                                            className="delete-btn"
                                            onClick={() =>
                                                removeFile(
                                                    index
                                                )
                                            }
                                        >
                                            <FiTrash2 />
                                        </button>
                                    </div>
                                </div>
                            )
                        )}
                    </div>

                    <div className="upload-note">
                        You can upload multiple
                        files. Maximum file size:
                        25 MB per file.
                    </div>
                </>
            )}
        </div>
    );
};

export default DocumentUpload;